/**
 * 基于elementui表单验证库
 * by cbb at 2021/6/29
 * 页面配置rules规则字段要与函数名保持一致
 */
import { Toast } from 'vant'

const validateForm = {
  required: (value, text) => {
    if (!value) {
      Toast({
        message: text.message
      })
      return false
    } else {
      return true
    }
  },
  // 验证手机号
  mobile: (value) => {
    const mobileReg = /^1[3456789]\d{9}$/
    if (!value) {
      return true
    } else if (!mobileReg.test(value)) {
      Toast({
        message: '请输入正确手机号',
        getContainer: '.id-card-box'
      })
      return false
    } else {
      return true
    }
  },
  // 校验护照
  passPort: (value) => {
    var checkPassWor = (password) => {
      //必须为字母加数字且长度不小于8位
      var str = password
      var reg1 = new RegExp(/^[0-9A-Za-z]+$/)
      if (!reg1.test(str)) {
        return false
      }
      var reg = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/)
      if (reg.test(str)) {
        return true
      } else {
        return false
      }
    }
    if (!value) {
      return true
    } else if (!checkPassWor(value)) {
      Toast({
        message: '请输入正确的护照'
      })
      return false
    } else {
      return true
    }
  },
  // 验证身份证号
  idcard: (value) => {
    if (!value) {
      return true
    }
    var checkID = function (val) {
      if (checkCode(val)) {
        var date = val.substring(6, 14)
        if (checkDate(date)) {
          if (checkProv(val.substring(0, 2))) {
            return true
          }
        }
      }
      Toast({
        message: '请输入正确身份证号码',
        getContainer: '.id-card-box'
      })
      return false
    }
    // 校验校验码
    var checkCode = function (val) {
      var p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      var factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      var parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      var code = val.substring(17)
      if (p.test(val)) {
        var sum = 0
        for (var i = 0; i < 17; i++) {
          sum += val[i] * factor[i]
        }
        if (parity[sum % 11] == code.toUpperCase()) {
          return true
        }
      }
      return false
    }
    // 校验出生日期
    var checkDate = function (val) {
      var pattern = /^(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)$/
      if (pattern.test(val)) {
        var year = val.substring(0, 4)
        var month = val.substring(4, 6)
        var date = val.substring(6, 8)
        var date2 = new Date(year + '-' + month + '-' + date)
        if (date2 && date2.getMonth() == parseInt(month) - 1) {
          return true
        }
      }
      return false
    }
    // 校验省级地址码
    var checkProv = function (val) {
      var pattern = /^[1-9][0-9]/
      var provs = {
        11: '北京',
        12: '天津',
        13: '河北',
        14: '山西',
        15: '内蒙古',
        21: '辽宁',
        22: '吉林',
        23: '黑龙江 ',
        31: '上海',
        32: '江苏',
        33: '浙江',
        34: '安徽',
        35: '福建',
        36: '江西',
        37: '山东',
        41: '河南',
        42: '湖北 ',
        43: '湖南',
        44: '广东',
        45: '广西',
        46: '海南',
        50: '重庆',
        51: '四川',
        52: '贵州',
        53: '云南',
        54: '西藏 ',
        61: '陕西',
        62: '甘肃',
        63: '青海',
        64: '宁夏',
        65: '新疆',
        71: '台湾',
        81: '香港',
        82: '澳门'
      }
      if (pattern.test(val)) {
        if (provs[val]) {
          return true
        }
      }
      return false
    }
    if (!checkID(value)) {
      return false
    } else {
      return true
    }
  },
  // 验证汉字
  han: (value, text) => {
    var han = /^[\u4e00-\u9fa5]+$/
    if (!value) {
      return true
    } else if (!han.test(value)) {
      Toast({
        message: text.message
      })
      return false
    } else {
      return true
    }
  },
  // 密码校验
  password: (value) => {
    const passRule = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*\d)[A-Za-z\d]{8,}$/
    if (value === '') {
      return true
      // callback(new Error('请再次输入密码'));
    } else if (value && !passRule.test(value)) {
      return false
    } else {
      return true
    }
  }
}

export default validateForm
